import './NewsBlock.scss'
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {connect} from "react-redux";
import {generateFileMediaUrl} from "../../../utils/generateMediaUrl";
import {NewsArrIcon} from "../../../assets/images";
import moment from "moment";
import {Link} from "react-router-dom";

function NewsBlock(props) {
    const {news,staticTexts,id} = props
    return <div className={'newsBlock-wrapper'}>
        {
            news?.length ? <div className={'newsBlock-header'}>
                <div className={'newsBlock-title'}>
                    {staticTexts?.homepage_news_title}
                </div>
                {/*<div className={'newsBlock-description'}>*/}
                {/*    {staticTexts?.homepage_news_description}*/}
                {/*</div>*/}
                <div className={'newsBlocks'}>
                    {
                        news?.length && news?.filter(e => e.id !== id)?.map(item => {
                            return <Link to={`/news/${item?.slug}`} className={'newsBlocks-card'} key={item.id}>
                                <div className={'newsBlocks-card-img-wrapper'}>
                                    <div className={'newsBlocks-card-img'}>
                                        <img src={generateFileMediaUrl(item?.mediaMain?.coverPath || item?.mediaMain?.path)} alt=""/>
                                    </div>
                                </div>
                                <div className={'newsBlocks-card-info'}>
                                    <div className={'newsBlocks-card-date'}>
                                        {moment(item?.date).format("MMM Do")}
                                    </div>
                                    <div  className={'newsBlocks-card-title'}>
                                        <span>{item?.title}</span> <NewsArrIcon/>
                                    </div>
                                </div>
                            </Link>
                        })
                    }
                </div>
            </div> : ''
        }
    </div>
}const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
        'news',
    ])
};
const mapDispatchToProps = {
};
export default connect(mapStateToProps,mapDispatchToProps)(NewsBlock);